import { Box, Divider, SxProps, Theme, useTheme } from "@mui/material";
import { Devices, RoomService } from "@mui/icons-material";

export const RESOURCE_BOOKING_ICON_WIDTH = "34px";
export const RESOURCE_BOOKING_ICON_HEIGHT = "32px";

type ResourceBookingIconProps = {
  sx?: SxProps<Theme>;
};

export function ResourceBookingIcon({ sx }: Readonly<ResourceBookingIconProps>) {
  const theme = useTheme();
  const iconFontSize = `${Math.round(Number.parseFloat(RESOURCE_BOOKING_ICON_WIDTH) * 0.6)}px`;

  const clippedIconSx = {
    fontSize: iconFontSize,
    flexShrink: 0
  };

  return (
    <Box
      data-testid="resource-booking-icon"
      aria-hidden
      sx={[
        {
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          width: RESOURCE_BOOKING_ICON_WIDTH,
          height: RESOURCE_BOOKING_ICON_HEIGHT,
          color: theme.palette.text.primary
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          overflow: "hidden"
        }}
      >
        <Devices sx={{ ...clippedIconSx, transform: "scale(1)", transformOrigin: "left center" }} />
      </Box>

      <Divider
        orientation="vertical"
        flexItem
        sx={{
          height: "100%",
          borderColor: theme.palette.divider
        }}
      />

      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          overflow: "hidden"
        }}
      >
        <RoomService
          sx={{ ...clippedIconSx, transform: "scale(1.25)", transformOrigin: "right center" }}
        />
      </Box>
    </Box>
  );
}
